import { FC } from 'react'

import { useAppDispatch, useAppSelector } from '@/stores/hooks.ts'
import { DebouncedTextField } from '@/components'
import { sbpPaymentsActions } from '@/stores/slices/sbp-payments-slice.ts'

export const SbpDebouncedTextField: FC = () => {
  const dispatch = useAppDispatch()
  const sbpType = useAppSelector((state) => state.sbpPayments.sbpType)
  const requestId = useAppSelector((state) => state.sbpPayments.requestId)
  const reference = useAppSelector((state) => state.sbpPayments.reference)

  const handleRequestIdChange = (value: string) =>
    dispatch(
      sbpPaymentsActions.setFilter({
        filterKey: 'requestId',
        filterValue: value,
      })
    )

  const handleReferenceChange = (value: string) =>
    dispatch(
      sbpPaymentsActions.setFilter({
        filterKey: 'reference',
        filterValue: value,
      })
    )

  return sbpType === 'B2C' ? (
    <DebouncedTextField
      key="2C"
      initValue={reference}
      label={'№ заявки B2C'}
      onChange={handleReferenceChange}
      doReset={reference === undefined}
    />
  ) : (
    <DebouncedTextField
      key="2B"
      initValue={requestId}
      label={'№ заявки QR'}
      onChange={handleRequestIdChange}
      doReset={requestId === undefined}
    />
  )
}
